import { campaignPageNameSiteSection, getPlatform } from './analytics';

/**
 * Injects trv-page and trv-platform parameters into an API request's 'values' object.
 * @param existingValues - The original 'values' object from the API call.
 * @param pageName - Optional. The name of the page for tracking. If not provided, it's derived from the campaign page name.
 * @returns A new object containing both original and tracking parameters.
 */
export const withTrackingParams = (existingValues: Record<string, any> = {}, pageName?: string) => {
  const platform = getPlatform();

  let pageNameToUse = pageName;
  if (!pageNameToUse && typeof window !== 'undefined') {
    pageNameToUse = campaignPageNameSiteSection(window.location.pathname).pageName;
  }

  const trackingParams: Record<string, any> = {
    'trv-platform': platform,
  };

  if (pageNameToUse) {
    trackingParams['trv-page'] = pageNameToUse;
  }

  return {
    ...existingValues,
    ...trackingParams,
  };
};
